import { render, staticRenderFns } from "./HostsList.vue?vue&type=template&id=2a683174&scoped=true"
import script from "./HostsList.vue?vue&type=script&lang=js"
export * from "./HostsList.vue?vue&type=script&lang=js"
import style0 from "./HostsList.vue?vue&type=style&index=0&id=2a683174&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a683174",
  null
  
)

export default component.exports